<template>
  <div class="fab-container" :style="containerStyle" @touchstart="onTouchStart" @touchmove="onTouchMove"
    @touchend="onTouchEnd" @click="handleClick">
    <!-- 增加一个光泽层，模拟玻璃反光 -->
    <div class="fab-glass-effect"></div>

    <div class="fab-button" :style="button3DStyle">
      <!-- 动态图标 -->
      <svg class="icon" viewBox="0 0 1024 1024" width="20" height="20">
        <path v-if="isHome"
          d="M512 896a384 384 0 1 1 352.6-232.9 32 32 0 1 1-58.9-25A320 320 0 1 0 512 832a32 32 0 0 1 0 64z"
          fill="currentColor" />
        <path v-else
          d="M609.408 149.504 272.64 486.272a32 32 0 0 0 0 45.248l336.768 336.768a32 32 0 1 0 45.248-45.248L340.672 508.928l313.984-313.984a32 32 0 1 0-45.248-45.248z"
          fill="currentColor" />
      </svg>
      <!-- 动态文字 -->
      <!-- <span class="text">{{ isHome ? '刷新' : '返回' }}</span> -->
    </div>
  </div>
</template>

<script>
import { shallowRef } from 'vue'
export default {
  name: 'FloatingAction',
  data () {
    return {
      dragging: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      // 使用 shallowRef 包裹位置数据，减少 Vue 响应式开销
      position: shallowRef({ x: 16, y: 100 }),
      // 记录3D旋转的角度
      rotateX: 0,
      rotateY: 0,
      screenWidth: 0,
      screenHeight: 0
    }
  },
  computed: {
    isHome () {
      return !this.$route.meta.showBackBtn
    },
    containerStyle () {
      return {
        left: 'auto',
        top: 'auto',
        right: this.position.x + 'px',
        bottom: this.position.y + 'px'
      }
    },
    // 绑定 3D 旋转样式
    button3DStyle () {
      return {
        transform: `perspective(1000px) rotateX(${this.rotateX}deg) rotateY(${this.rotateY}deg) scale(${this.dragging ? 1.05 : 1})`,
        transition: this.dragging ? 'none' : 'transform 0.5s ease-out'
      }
    }
  },
  created () {
    this.screenWidth = document.documentElement.clientWidth
    this.screenHeight = document.documentElement.clientHeight
    const savedPos = localStorage.getItem('floatingBtnPos')
    if (savedPos) {
      const pos = JSON.parse(savedPos)
      this.position = {
        x: pos.x || 16,
        y: pos.y || 100
      }
    } else {
      this.position = {
        x: 16,
        y: 100
      }
    }
  },
  methods: {
    onTouchStart (e) {
      this.dragging = true
      this.startX = e.touches[0].clientX
      this.startY = e.touches[0].clientY
      this.currentX = this.position.x
      this.currentY = this.position.y

      // 拖拽开始时，移除过渡效果，保证绝对跟手
      this.$el.querySelector('.fab-button').style.transition = 'none'
    },
    onTouchMove (e) {
      if (!this.dragging) return

      // 阻止页面默认滚动，防止拖拽时页面跟着动
      e.preventDefault()

      const moveX = this.startX - e.touches[0].clientX
      const moveY = this.startY - e.touches[0].clientY

      let newX = this.currentX + moveX
      let newY = this.currentY + moveY
      const maxX = this.screenWidth / 2
      const maxY = this.screenHeight / 2
      newX = Math.max(0, Math.min(newX, maxX))
      newY = Math.max(0, Math.min(newY, maxY))

      // 直接修改 shallowRef 的值，性能极高
      this.position = { x: newX, y: newY }

      // 优化：降低 3D 倾斜的计算频率，避免每像素都算一次三角函数
      // 只有当移动距离较大时才更新角度，或者简单地将移动距离除以一个更大的数
      if (Math.abs(moveX) > 2 || Math.abs(moveY) > 2) {
        this.rotateY = moveX / 8 // 减小倾斜幅度，降低计算量
        this.rotateX = -moveY / 8
      }
    },
    onTouchEnd () {
      this.dragging = false
      this.rotateX = 0
      this.rotateY = 0

      // 拖拽结束，恢复 CSS 的 transition 动画，让回弹和吸边更平滑
      this.$el.querySelector('.fab-button').style.transition = 'transform 0.5s ease-out'

      this.snapToCorner()
    },
    snapToCorner () {
      const threshold = 50
      const offset = 16
      if (this.position.x < threshold) this.position.x = offset
      if (this.position.y < threshold) this.position.y = offset
      localStorage.setItem('floatingBtnPos', JSON.stringify(this.position))
    },
    handleClick () {
      if (this.isHome) {
        window.location.reload()
      } else {
        if (window.history.length > 1) {
          this.$router.back()
        } else {
          // 如果没有上一页，就跳转到指定的首页路由
          this.$router.replace('/home')
        }
        // this.$router.back().catch(err => {
        //   console.warn('Router back failed:', err)
        //   history.back()
        // })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .fab-container {
    position: fixed;
    z-index: 9999;
    width: 110px;
    height: 110px;
    padding: 10px;
    margin: -10px;

    /* 1. 禁用拖拽时的默认行为，防止卡顿和选中文字 */
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
  }

  .fab-button {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 25px;

    /* 核心：3D 变换的基准 */
    transform-style: preserve-3d;
    will-change: transform;

    /* 毛玻璃模糊与径向渐变背景 */
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    background: rgba(0, 0, 0, 0.3);
    // background: radial-gradient(circle at center,
    //     color-mix(in srgb, var(--weui-BG-0, #f7f7f7), transparent 10%) 0%,
    //     color-mix(in srgb, var(--weui-BG-0, #f7f7f7), transparent 40%) 60%,
    //     color-mix(in srgb, var(--weui-BG-0, #f7f7f7), transparent 100%) 100%);

    /* 模拟玻璃厚度的边框与光影 */
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow:
      0 10px 20px rgba(0, 0, 0, 0.1),
      /* 外部投影，制造悬浮高度 */
      inset 0 1px 1px rgba(255, 255, 255, 0.6),
      /* 顶部内高光 */
      inset 0 -1px 1px rgba(0, 0, 0, 0.15);
    /* 底部内阴影 */

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    overflow: hidden;
    /* 隐藏溢出的光泽层 */

    &:active {
      /* 点击时稍微缩小，增加按压反馈 */
      transform: perspective(1000px) scale(0.95) !important;
    }
    /* 2. 开启硬件加速，告诉浏览器这个元素要频繁变动 */
    will-change: transform;
    /* 3. 提前开启 3D 渲染层，强制使用 GPU */
    transform: translateZ(0);
    backface-visibility: hidden;

    /* 4. 拖拽时彻底移除 transition，松手后再加回来，实现丝滑跟手 */
    transition: transform 0.5s ease-out;
  }

  /* 增加一层动态光泽，让玻璃更有通透感 */
  .fab-glass-effect {
    position: absolute;
    top: 80%;
    left: 15%;
    width: 80%;
    height: 15%;
    background: linear-gradient(to right,
        transparent,
        rgba(255, 255, 255, 0.3),
        transparent);
    transform: skewX(-25deg);
    pointer-events: none;
    /* 可以在拖拽或悬停时通过 JS 触发这个光泽的扫过动画 */
  }

  .icon {
    color: rgba(255, 255, 255, 0.9);
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    /* 图标也带一点投影 */
    transform: translateZ(10px);
    /* 让图标在 3D 空间中稍微凸起 */
  }

  .text {
    font-size: 20px;
    font-weight: 500;
    color: rgba(51, 51, 51, 0.8);
    transform: translateZ(10px);
    /* 让文字也稍微凸起 */
  }
</style>
